export const FanAndFollowersTypes = {
  FAN: "FAN",
  FOLLOWER: "FOLLOWER"
};

export const FanAndFollowersNames = {
  FAN: "Fan",
  FOLLOWER: "Follower"
};
